import React from 'react'
import CaseStudiesHero from './section/CaseStudiesHero.js'
import ProjectSection from './section/ProjectSection.js'
import Acrossclientwork from './section/Acrossclientwork.js'

const CaseStudies = () => {
  return (
    <>
    <CaseStudiesHero/>
    <ProjectSection/>
    <Acrossclientwork/>
    </>
  )
}

export default CaseStudies